import { FooterComponent } from "../FooterComponent/FooterComponent";
import { LogoAnimationComponent } from "./LogoAnimationComponent/LogoAnimationComponent";
import "./LandingPageComponent.scss";

export function LandingPageComponent() {
  return (
    <div className="landing-page">
      <div className="logo-component flex-column align-items-center justify-content-center">
        <div className="coming-soon d-flex justify-content-center align-items-center">COMING SOON</div>
        <LogoAnimationComponent />
        <div className="footer">
          <FooterComponent />
        </div>
      </div>
    </div>
  );
}
